import { getLogger } from '@lib/observability/logging/log.client';

const { logInfo } = getLogger('lib/clerk/utils/get-clerk-user-facing-error');
const VERIFICATION_STRATEGY_REGEX = /verification strategy/i;

interface ClerkErrorContext {
  flow: 'sign-in' | 'sign-up' | 'google-sign-in';
  userInfo?: Record<string, unknown>;
}

/**
 * Checks if a Clerk error is an "Invalid Verification Strategy" error and returns
 * a user-friendly message. Logs the original error with user context for debugging.
 *
 * @returns A user-friendly error message if the error is a verification strategy error, or `null` otherwise.
 */
export function getClerkUserFacingError(
  clerkMessage: string,
  context: ClerkErrorContext
): string | null {
  if (!VERIFICATION_STRATEGY_REGEX.test(clerkMessage)) return null;

  logInfo(`Clerk invalid verification strategy error during ${context.flow}`, {
    ...context.userInfo,
    clerkError: clerkMessage,
  });

  return context.flow === 'sign-up'
    ? 'Unable to create your account. Please try again or use a different method.'
    : 'Unable to sign in. Please try again or use a different method.';
}
